import { KText } from '@/ui-library/components/text';
import { Box, Flex } from '@chakra-ui/react';
import { ClockRewind } from '@kula-ai/icons-core';
import { useEffect, useRef } from 'react';
import { CandidateItem } from '@/pages/AISearch/components/searchItems/CandidateItem';

interface RecentlyUsedProps {
  recentSearchQueries: string[];
  recentlyViewedCandidates: any[];
  selectedIndex: number;
  onSearchQueryClick?: (_query: string) => void;
}

const RecentQueryItem = ({
  query,
  isSelected,
  onClick,
}: {
  query: string;
  isSelected: boolean;
  onClick: () => void;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isSelected]);

  return (
    <Flex
      ref={ref}
      align="center"
      gap="10px"
      p="10px"
      cursor="pointer"
      _hover={{ bg: 'secondary-50' }}
      bg={isSelected ? 'secondary-50' : undefined}
      borderRadius="6px"
      onClick={onClick}
    >
      <Flex
        minWidth="36px"
        minHeight="36px"
        bg="secondary-50"
        borderRadius="6px"
        p="4px"
        alignItems="center"
        justifyContent="center"
      >
        <ClockRewind
          size={18}
          color="var(--kula-colors-secondary-700)"
          className="kula-icon"
        />
      </Flex>
      <KText size="sm-regular" color="secondary-700">
        {query}
      </KText>
    </Flex>
  );
};

export const RecentlyUsed = ({
  recentSearchQueries,
  recentlyViewedCandidates,
  selectedIndex,
  onSearchQueryClick,
}: RecentlyUsedProps) => {
  const queriesCount = recentSearchQueries.length;

  return (
    <Box padding="20px 0">
      {queriesCount > 0 && (
        <Box mb={recentlyViewedCandidates?.length > 0 ? '20px' : '0px'}>
          <KText
            size="xs-semi-bold"
            color="secondary-600"
            textTransform="uppercase"
          >
            Recent Searches
          </KText>
          <Flex direction="column" gap="10px" mt="12px">
            {recentSearchQueries.map((query, index) => (
              <RecentQueryItem
                key={index}
                query={query}
                isSelected={selectedIndex === index}
                onClick={() => onSearchQueryClick?.(query)}
              />
            ))}
          </Flex>
        </Box>
      )}

      {recentlyViewedCandidates?.length > 0 && (
        <Box>
          <KText
            size="xs-semi-bold"
            color="secondary-600"
            textTransform="uppercase"
          >
            Recently Viewed
          </KText>
          <Box mt="12px">
            {recentlyViewedCandidates.map((candidate, index) => (
              <CandidateItem
                key={candidate.id}
                item={candidate}
                isRecentViewed={true}
                isSelected={selectedIndex === queriesCount + index}
                jobs={candidate?.job_application_details || []}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};
